<template>
    <div :class="`main-banner swiper-container ${css_class}`">
        <div class="swiper-wrapper" v-if="slider">
            <div class="swiper-slide" v-for="slide in slider" :key="slide.id">
                <div class="main-banner__item">
                    <SuperLink 
                        class="main-banner__infos"
                        :href="slide.link">
                        <p class="noticies__label" v-if="slide.hat">{{slide.hat}}</p>
                        <p class="noticies__label" v-else>{{slide.link.editorial.title}}</p>
                        <p class="main-banner__title">{{ slide.title }}</p>
                        <p class="main-banner__subtitle">{{slide.subtitle}}</p>
                    </SuperLink>
                    <img v-if="slide.image" :src="utils.image(slide.image, width, height)" alt="" />
                    <img v-else-if="slide.link.image" :src="utils.image(slide.link.image, width, height)" alt="" />
                    <img v-else src="@/assets/images/search-placeholder.jpg" />
                </div>
            </div>
        </div>
        <div class="swiper-pagination swiper-pagination--main-banner"></div>
        <div class="swiper-button-prev swiper-button-prev--main-banner"></div>
        <div class="swiper-button-next swiper-button-next--main-banner"></div>
    </div>
</template>

<script>
import Swiper from 'swiper'
import utils from '@/utils'
import SuperLink from '@/components/SuperLink'

export default {
    name: 'Carousel',
    components:{SuperLink},
    props:['slider', 'width', 'height', 'css_class'],
    data: function () {
        return {
            utils: utils
        }
    },
    methods: {
        start() {
            new Swiper(".main-banner", {
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination--main-banner',
                    type: 'bullets',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next--main-banner',
                    prevEl: '.swiper-button-prev--main-banner',
                },
                breakpoints: {
                    // when window width is >= 767px
                    767: {
                        slidesPerView: 1,
                    },
                }
            })
        }
    },
    mounted() {
        this.start()
    }
}
</script>